export interface ComicChapter {
  id: number;
  title: string;
  views: string;
  updated: string;
}

export interface Comic {
  id: number;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  author: string;
  status: '连载中' | '已完结';
  latestChapter: string;
  totalChapters: number;
  rating: string;
  views: string;
  favorite: string;
  intro: string;
  lastUpdated: string;
  isNew?: boolean;
  chapters: ComicChapter[];
}

export const categories: { name: string; desc: string; icon: string }[] = [
  { name: '热血战斗', desc: '燃烧斗志 燃到飞起', icon: 'ri-fire-line' },
  { name: '恋爱校园', desc: '青涩心动 怦然青春', icon: 'ri-heart-3-line' },
  { name: '玄幻仙侠', desc: '御剑而行 问鼎苍穹', icon: 'ri-sword-line' },
  { name: '悬疑惊悚', desc: '层层反转 寒意上头', icon: 'ri-ghost-2-line' },
  { name: '搞笑日常', desc: '轻松解压 笑到肚子疼', icon: 'ri-emotion-laugh-line' },
  { name: '科幻机甲', desc: '未来战场 硬核浪漫', icon: 'ri-rocket-2-line' },
  { name: '运动竞技', desc: '热血赛场 全力以赴', icon: 'ri-flag-line' },
  { name: '奇幻冒险', desc: '勇者集结 踏上旅程', icon: 'ri-compass-3-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '星穹破晓',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20hero%20with%20flaming%20sword%20against%20a%20dark%20space%20nebula%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20clean%20vector%20style%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '热血战斗',
    tags: ['热血', '战斗', '星际'],
    author: '晨光漫社',
    status: '连载中',
    latestChapter: '第 128 话',
    totalChapters: 128,
    rating: '9.6',
    views: '2.4亿',
    favorite: '86万',
    intro: '末世星穹异变，少年叶辰觉醒被封印的炎之血脉，踏上守护人族、冲破星穹的燃血征途。每一场战斗都是信念的较量，每一个同伴都值得以命相托。',
    lastUpdated: '2026-08-18',
    isNew: true,
    chapters: [
      { id: 128, title: '第 128 话 星火的抉择', views: '23.5万', updated: '2026-08-18' },
      { id: 127, title: '第 127 话 燃烧的羁绊', views: '22.1万', updated: '2026-08-15' },
      { id: 126, title: '第 126 话 破晓之光', views: '20.8万', updated: '2026-08-12' },
      { id: 125, title: '第 125 话 意志的试炼', views: '19.9万', updated: '2026-08-09' },
      { id: 124, title: '第 124 话 炎之血脉', views: '18.6万', updated: '2026-08-06' },
    ],
  },
  {
    id: 2,
    title: '心动信号百分百',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20anime%20manga%20cover%20of%20high%20school%20boy%20and%20girl%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20cream%20colors%2C%20gently%20blushing%20faces%2C%20cute%20clean%20illustration%2C%20warm%20atmosphere%2C%20high%20detail&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '恋爱校园',
    tags: ['恋爱', '校园', '甜宠'],
    author: '桃子汽水',
    status: '连载中',
    latestChapter: '第 96 话',
    totalChapters: 96,
    rating: '9.4',
    views: '1.8亿',
    favorite: '64万',
    intro: '学霸林澈与元气少女苏晚在学校樱花树下意外相遇，一场双向奔赴的甜蜜暗恋就此展开。误会与心动并存，青春的味道刚刚好。',
    lastUpdated: '2026-08-18',
    isNew: true,
    chapters: [
      { id: 96, title: '第 96 话 樱花的约定', views: '18.9万', updated: '2026-08-18' },
      { id: 95, title: '第 95 话 心跳加速', views: '17.4万', updated: '2026-08-14' },
      { id: 94, title: '第 94 话 教室的秘密', views: '16.2万', updated: '2026-08-11' },
      { id: 93, title: '第 93 话 放学后的告白', views: '15.7万', updated: '2026-08-07' },
    ],
  },
  {
    id: 3,
    title: '剑问九州',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20fantasy%20anime%20manga%20cover%20of%20a%20swordsman%20standing%20on%20mountain%20peak%20with%20ancient%20floating%20swords%2C%20misty%20clouds%2C%20warm%20golden%20and%20vermillion%20colors%2C%20xianxia%20style%20illustration%2C%20majestic%2C%20high%20detail&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '玄幻仙侠',
    tags: ['仙侠', '修炼', '逆袭'],
    author: '云起画师',
    status: '连载中',
    latestChapter: '第 210 话',
    totalChapters: 210,
    rating: '9.7',
    views: '3.1亿',
    favorite: '102万',
    intro: '废柴少年姜无涯偶得上古剑诀，于乱世九州中一剑问天。修剑、炼心、破局，他以手中三尺青锋，书写属于自己的仙途传奇。',
    lastUpdated: '2026-08-17',
    isNew: true,
    chapters: [
      { id: 210, title: '第 210 话 一剑破万法', views: '26.3万', updated: '2026-08-17' },
      { id: 209, title: '第 209 话 问剑苍梧', views: '24.8万', updated: '2026-08-13' },
      { id: 208, title: '第 208 话 心魔劫', views: '23.1万', updated: '2026-08-10' },
      { id: 207, title: '第 207 话 剑心通明', views: '22.6万', updated: '2026-08-06' },
    ],
  },
  {
    id: 4,
    title: '雾城迷案',
    cover: 'https://readdy.ai/api/search-image?query=dark%20mystery%20anime%20manga%20cover%20with%20a%20detective%20figure%20in%20a%20foggy%20rainy%20city%20alley%2C%20moody%20lighting%2C%20teal%20and%20charcoal%20tones%2C%20suspenseful%20atmosphere%2C%20noir%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '悬疑惊悚',
    tags: ['悬疑', '推理', '都市'],
    author: '夜行笔客',
    status: '连载中',
    latestChapter: '第 68 话',
    totalChapters: 68,
    rating: '9.3',
    views: '9800万',
    favorite: '35万',
    intro: '雾都小城接连发生离奇失踪案，资深刑警顾淮与神秘少女联手抽丝剥茧。迷雾之后，真相比想象中更接近身边的人。',
    lastUpdated: '2026-08-16',
    chapters: [
      { id: 68, title: '第 68 话 迷雾中的线索', views: '12.4万', updated: '2026-08-16' },
      { id: 67, title: '第 67 话 双重嫌疑', views: '11.9万', updated: '2026-08-12' },
      { id: 66, title: '第 66 话 雨夜证人', views: '11.2万', updated: '2026-08-08' },
    ],
  },
  {
    id: 5,
    title: '今天也要元气满满',
    cover: 'https://readdy.ai/api/search-image?query=cute%20comedy%20anime%20manga%20cover%20of%20a%20cheerful%20office%20girl%20with%20a%20cat%20and%20coffee%2C%20bright%20warm%20sunshine%20yellow%20and%20orange%20palette%2C%20fun%20relaxed%20daily%20life%20slice%20style%2C%20playful%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '搞笑日常',
    tags: ['搞笑', '日常', '治愈'],
    author: '阿糖工坊',
    status: '连载中',
    latestChapter: '第 154 话',
    totalChapters: 154,
    rating: '9.2',
    views: '1.5亿',
    favorite: '52万',
    intro: '打工人阿圆每天上演各种爆笑日常，跟猫主子斗智斗勇、和同事相爱相杀。生活虽然琐碎，但只要元气满满，处处都是笑点。',
    lastUpdated: '2026-08-18',
    isNew: true,
    chapters: [
      { id: 154, title: '第 154 话 加班实录', views: '15.1万', updated: '2026-08-18' },
      { id: 153, title: '第 153 话 猫咪的报复', views: '14.6万', updated: '2026-08-15' },
      { id: 152, title: '第 152 话 周五的快乐', views: '13.9万', updated: '2026-08-11' },
    ],
  },
  {
    id: 6,
    title: '钢铁苍穹',
    cover: 'https://readdy.ai/api/search-image?query=sci-fi%20mecha%20anime%20manga%20cover%20of%20a%20massive%20robot%20battle%20in%20space%20with%20explosions%2C%20pilot%20silhouette%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20hardcore%20mecha%20style%20illustration%2C%20dynamic%2C%20high%20detail&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '科幻机甲',
    tags: ['科幻', '机甲', '战争'],
    author: '铁心画室',
    status: '连载中',
    latestChapter: '第 88 话',
    totalChapters: 88,
    rating: '9.5',
    views: '1.2亿',
    favorite: '41万',
    intro: '人类失去地球表面之后，少年飞行员在残存机甲中觉醒驾驶天赋，驾驶「苍穹」机甲冲上星海，为最后的家园而战。',
    lastUpdated: '2026-08-15',
    chapters: [
      { id: 88, title: '第 88 话 苍穹之翼', views: '14.8万', updated: '2026-08-15' },
      { id: 87, title: '第 87 话 驾驶舱觉醒', views: '13.6万', updated: '2026-08-11' },
      { id: 86, title: '第 86 话 星海狙击', views: '12.9万', updated: '2026-08-07' },
    ],
  },
  {
    id: 7,
    title: '灌篮·巅峰对决',
    cover: 'https://readdy.ai/api/search-image?query=sports%20anime%20manga%20cover%20of%20a%20basketball%20player%20slam%20dunking%20in%20a%20crowded%20arena%2C%20intense%20action%2C%20warm%20orange%20and%20amber%20palette%2C%20energetic%20sports%20illustration%2C%20sweat%20and%20determination%2C%20high%20detail&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '运动竞技',
    tags: ['篮球', '竞技', '热血'],
    author: '疾风画社',
    status: '已完结',
    latestChapter: '第 240 话',
    totalChapters: 240,
    rating: '9.8',
    views: '3.6亿',
    favorite: '120万',
    intro: '平凡少年林飞怀揣篮球梦加入校队，从替补席一路拼到全国巅峰赛。汗水与呐喊交织，这就是青春最热血的注脚。',
    lastUpdated: '2026-07-30',
    chapters: [
      { id: 240, title: '第 240 话 终场哨响', views: '30.2万', updated: '2026-07-30' },
      { id: 239, title: '第 239 话 巅峰之战', views: '28.9万', updated: '2026-07-28' },
      { id: 238, title: '第 238 话 最后的进攻', views: '27.6万', updated: '2026-07-26' },
    ],
  },
  {
    id: 8,
    title: '迷雾森林的勇者',
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20adventure%20anime%20manga%20cover%20of%20a%20brave%20adventurer%20with%20a%20bow%20entering%20a%20magical%20misty%20forest%20with%20giant%20luminous%20plants%2C%20warm%20amber%20and%20emerald%20palette%2C%20epic%20fantasy%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '奇幻冒险',
    tags: ['奇幻', '冒险', '魔法'],
    author: '月影工作室',
    status: '连载中',
    latestChapter: '第 45 话',
    totalChapters: 45,
    rating: '9.0',
    views: '6600万',
    favorite: '22万',
    intro: '误入迷雾森林的少女白栀，与精灵弓箭手结伴同行。他们需要穿越层层迷雾，找到传说中的永夜之果，才能回到家园。',
    lastUpdated: '2026-08-14',
    isNew: true,
    chapters: [
      { id: 45, title: '第 45 话 永夜之果', views: '8.9万', updated: '2026-08-14' },
      { id: 44, title: '第 44 话 雾中的密语', views: '8.4万', updated: '2026-08-10' },
      { id: 43, title: '第 43 话 精灵的誓言', views: '8.1万', updated: '2026-08-06' },
    ],
  },
  {
    id: 9,
    title: '逆光而行',
    cover: 'https://readdy.ai/api/search-image?query=drama%20anime%20manga%20cover%20of%20a%20young%20man%20walking%20alone%20toward%20sunrise%20on%20a%20city%20rooftop%2C%20backlit%20silhouette%2C%20warm%20amber%20and%20rose%20palette%2C%20emotional%20slice%20of%20life%20illustration%2C%20cinematic%2C%20high%20detail&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '恋爱校园',
    tags: ['青春', '成长', '治愈'],
    author: '橙子漫画',
    status: '已完结',
    latestChapter: '第 132 话',
    totalChapters: 132,
    rating: '9.3',
    views: '1.1亿',
    favorite: '46万',
    intro: '自卑的少年在摄影社遇见了照亮他的女孩，也在这段逆光而行的青春里，慢慢学会了如何成为自己的光。',
    lastUpdated: '2026-06-20',
    chapters: [
      { id: 132, title: '第 132 话 逆光', views: '16.8万', updated: '2026-06-20' },
      { id: 131, title: '第 131 话 光的形状', views: '16.1万', updated: '2026-06-18' },
      { id: 130, title: '第 130 话 快门之后', views: '15.4万', updated: '2026-06-16' },
    ],
  },
  {
    id: 10,
    title: '都市异能录',
    cover: 'https://readdy.ai/api/search-image?query=urban%20superpower%20anime%20manga%20cover%20of%20a%20teenager%20with%20glowing%20energy%20hands%20in%20a%20modern%20city%20at%20night%2C%20teal%20and%20warm%20orange%20light%20effects%2C%20superhero%20style%20illustration%2C%20dynamic%2C%20high%20detail&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '热血战斗',
    tags: ['都市', '异能', '热血'],
    author: '青云漫客',
    status: '连载中',
    latestChapter: '第 175 话',
    totalChapters: 175,
    rating: '9.1',
    views: '8800万',
    favorite: '30万',
    intro: '平凡外卖员偶然觉醒空间异能，卷入都市背后不为人知的异能者世界。能力越大，责任越大，也越要守住本心。',
    lastUpdated: '2026-08-13',
    chapters: [
      { id: 175, title: '第 175 话 异能者大会', views: '11.7万', updated: '2026-08-13' },
      { id: 174, title: '第 174 话 空间裂缝', views: '11.0万', updated: '2026-08-09' },
      { id: 173, title: '第 173 话 觉醒时刻', views: '10.6万', updated: '2026-08-05' },
    ],
  },
  {
    id: 11,
    title: '山海异闻录',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20mythology%20anime%20manga%20cover%20of%20ancient%20mountain%20beasts%20and%20a%20young%20exorcist%20with%20talisman%20scrolls%2C%20warm%20vermillion%20and%20gold%20palette%2C%20classical%20chinese%20ink%20fantasy%20style%2C%20high%20detail&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '玄幻仙侠',
    tags: ['神话', '志怪', '东方'],
    author: '古画坊',
    status: '已完结',
    latestChapter: '第 320 话',
    totalChapters: 320,
    rating: '9.5',
    views: '2.9亿',
    favorite: '98万',
    intro: '以《山海经》为蓝本，讲述少年封妖使行走山海、收服异兽、封印妖邪的东方志怪传奇，画风古韵十足。',
    lastUpdated: '2026-05-15',
    chapters: [
      { id: 320, title: '第 320 话 山海归一', views: '28.4万', updated: '2026-05-15' },
      { id: 319, title: '第 319 话 百妖伏诛', views: '27.1万', updated: '2026-05-12' },
      { id: 318, title: '第 318 话 朱雀之心', views: '26.0万', updated: '2026-05-09' },
    ],
  },
  {
    id: 12,
    title: '全明星高中',
    cover: 'https://readdy.ai/api/search-image?query=esports%20anime%20manga%20cover%20of%20high%20school%20esports%20team%20celebrating%20with%20game%20controller%20and%20trophy%2C%20bright%20warm%20orange%20and%20amber%20palette%2C%20energetic%20esports%20illustration%2C%20youthful%2C%20high%20detail&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '运动竞技',
    tags: ['电竞', '竞技', '校园'],
    author: '闪光电玩社',
    status: '连载中',
    latestChapter: '第 72 话',
    totalChapters: 72,
    rating: '9.2',
    views: '7200万',
    favorite: '28万',
    intro: '五个性格迥异的高中生组成电竞战队，一路打进全国大赛。键盘上的热血，同样值得全力以赴。',
    lastUpdated: '2026-08-12',
    chapters: [
      { id: 72, title: '第 72 话 五人的羁绊', views: '9.8万', updated: '2026-08-12' },
      { id: 71, title: '第 71 话 决胜一局', views: '9.3万', updated: '2026-08-08' },
      { id: 70, title: '第 70 话 团队之心', views: '8.8万', updated: '2026-08-04' },
    ],
  },
  {
    id: 13,
    title: '午夜图书馆',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20anime%20manga%20cover%20of%20a%20haunted%20midnight%20library%20with%20flying%20books%20and%20a%20librarian%20ghost%2C%20moody%20teal%20and%20deep%20amber%20lighting%2C%20gothic%20fantasy%20illustration%2C%20mysterious%2C%20high%20detail&width=600&height=800&seq=manga-cover-13&orientation=portrait',
    category: '悬疑惊悚',
    tags: ['奇幻', '都市', '志怪'],
    author: '夜航星',
    status: '连载中',
    latestChapter: '第 51 话',
    totalChapters: 51,
    rating: '9.0',
    views: '5400万',
    favorite: '19万',
    intro: '只在午夜开放的图书馆，管理员是一只爱唠叨的猫头鹰。每本书都封印着一段被遗忘的故事，而读者的每一次借阅，都在改变现实。',
    lastUpdated: '2026-08-11',
    chapters: [
      { id: 51, title: '第 51 话 书灵苏醒', views: '7.6万', updated: '2026-08-11' },
      { id: 50, title: '第 50 话 借阅的代价', views: '7.2万', updated: '2026-08-07' },
      { id: 49, title: '第 49 话 猫头鹰管理员', views: '6.9万', updated: '2026-08-03' },
    ],
  },
  {
    id: 14,
    title: '舌尖上的漫画',
    cover: 'https://readdy.ai/api/search-image?query=delicious%20food%20anime%20manga%20cover%20of%20a%20chef%20cooking%20steaming%20ramen%20and%20sushi%2C%20appetizing%20warm%20yellow%20and%20orange%20palette%2C%20food%20illustration%20with%20steam%2C%20cozy%20warm%20lighting%2C%20high%20detail&width=600&height=800&seq=manga-cover-14&orientation=portrait',
    category: '搞笑日常',
    tags: ['美食', '日常', '治愈'],
    author: '暖汤屋',
    status: '已完结',
    latestChapter: '第 168 话',
    totalChapters: 168,
    rating: '9.4',
    views: '1.3亿',
    favorite: '48万',
    intro: '深夜食堂般的治愈美食漫画，每话一道家常菜、一个温暖的小故事。看完就想钻进厨房大展身手。',
    lastUpdated: '2026-04-28',
    chapters: [
      { id: 168, title: '第 168 话 家的味道', views: '14.2万', updated: '2026-04-28' },
      { id: 167, title: '第 167 话 一碗热汤面', views: '13.8万', updated: '2026-04-25' },
      { id: 166, title: '第 166 话 夜市烟火', views: '13.1万', updated: '2026-04-22' },
    ],
  },
  {
    id: 15,
    title: '量子少年',
    cover: 'https://readdy.ai/api/search-image?query=quantum%20science%20anime%20manga%20cover%20of%20a%20boy%20surrounded%20by%20glowing%20digital%20data%20particles%20in%20a%20virtual%20world%2C%20teal%20and%20warm%20orange%20holograms%2C%20futuristic%20sci-fi%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-15&orientation=portrait',
    category: '科幻机甲',
    tags: ['科幻', '虚拟', '成长'],
    author: '量子工坊',
    status: '连载中',
    latestChapter: '第 39 话',
    totalChapters: 39,
    rating: '8.9',
    views: '4100万',
    favorite: '15万',
    intro: '天才少年陈曦破解量子加密，意外进入虚拟数据世界。在这里，代码即是能力，算法即是魔法，他要用知识改写命运。',
    lastUpdated: '2026-08-10',
    isNew: true,
    chapters: [
      { id: 39, title: '第 39 话 数据洪流', views: '6.4万', updated: '2026-08-10' },
      { id: 38, title: '第 38 话 算法之心', views: '6.1万', updated: '2026-08-06' },
      { id: 37, title: '第 37 话 虚拟入侵', views: '5.9万', updated: '2026-08-02' },
    ],
  },
  {
    id: 16,
    title: '山海花嫁',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20xianxia%20anime%20manga%20cover%20of%20a%20couple%20in%20traditional%20chinese%20wedding%20attire%20under%20ancient%20pagoda%20and%20blossoms%2C%20warm%20vermillion%20and%20gold%2C%20sweet%20fantasy%20romance%20illustration%2C%20high%20detail&width=600&height=800&seq=manga-cover-16&orientation=portrait',
    category: '恋爱校园',
    tags: ['仙侠', '恋爱', '古风'],
    author: '凤羽阁',
    status: '连载中',
    latestChapter: '第 58 话',
    totalChapters: 58,
    rating: '9.1',
    views: '6900万',
    favorite: '31万',
    intro: '为躲避和亲，城主千金女扮男装逃入仙门，却和傲娇的少掌门结成欢喜冤家。一场跨越山海的古风甜恋就此展开。',
    lastUpdated: '2026-08-09',
    chapters: [
      { id: 58, title: '第 58 话 十里红妆', views: '9.1万', updated: '2026-08-09' },
      { id: 57, title: '第 57 话 少掌门的秘密', views: '8.7万', updated: '2026-08-05' },
      { id: 56, title: '第 56 话 初见惊鸿', views: '8.3万', updated: '2026-08-01' },
    ],
  },
];

export const newReleases = comics.filter((c) => c.isNew);
export const completedComics = comics.filter((c) => c.status === '已完结');
export const hotComics = [...comics]
  .sort((a, b) => Number(b.rating) - Number(a.rating))
  .slice(0, 10);

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(current: Comic, count = 4): Comic[] {
  return comics
    .filter((c) => c.id !== current.id && (c.category === current.category || c.tags.some((t) => current.tags.includes(t))))
    .slice(0, count);
}